// extracted by mini-css-extract-plugin
export default {"container":"Section4_container__7nolf","contentContainer":"Section4_contentContainer__ip9r0","quote":"Section4_quote__e01mX","btnContainer":"Section4_btnContainer__LtjB+"};